module.exports = "https://www.gc-pro.gnp.com.mx/2e8c4a44dbece93bf29c0709a886c279.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/documentos/03.png
// module id = 1030
// module chunks = 0 1